export const getLocation = () => window.location.pathname;
